import { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'

/**
 * OAuth Authorize endpoint
 * Converts standard OAuth /oauth/authorize requests to Webba ID login flow
 *
 * Expected params:
 * - client_id: The app_key
 * - redirect_uri: Where to redirect after auth
 * - response_type: Should be "code"
 * - scope: Requested scopes (openid, profile, email)
 * - state: CSRF protection state
 * - code_challenge: PKCE challenge
 * - code_challenge_method: Should be "S256"
 */
export function OAuthAuthorize() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    const clientId = searchParams.get('client_id')
    const redirectUri = searchParams.get('redirect_uri')
    const state = searchParams.get('state')
    const codeChallenge = searchParams.get('code_challenge')
    const codeChallengeMethod = searchParams.get('code_challenge_method') || 'S256'

    if (!clientId || !redirectUri) {
      navigate('/login', { replace: true })
      return
    }

    // Pass ALL OAuth params via URL to avoid sessionStorage issues
    const params = new URLSearchParams({
      app: clientId,
      redirect_uri: redirectUri,
    })
    if (state) params.set('state', state)
    if (codeChallenge) params.set('code_challenge', codeChallenge)
    if (codeChallengeMethod) params.set('code_challenge_method', codeChallengeMethod)

    navigate(`/login?${params.toString()}`, { replace: true })
  }, [searchParams, navigate])

  return null
}
